module.exports = __webpack_public_path__ + "img/jiti.baa08dd4.png";